import { createSlice } from '@reduxjs/toolkit';
import axios from 'utils/axios';
import { dispatch } from 'redux_data/store';

const slice = createSlice({
  name: 'customer', // ✅ ganti nama slice
  initialState: {
    hasError: null,
    isLoading: false,
    isLoadingDetail: false,
    datas: [],
    data: {},
  },
  reducers: {
    noError(state) {
      state.hasError = false;
    },
    unsetError(state) {
      state.hasError = null;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.hasError = JSON.stringify(action.payload);
    },
    startLoading: (state) => {
      state.isLoading = true;
    },
    startLoadingDetail: (state) => {
      state.isLoadingDetail = true;
    },
    setDatas: (state, action) => {
      state.isLoading = false;
      state.datas = action.payload;
    },
    setData: (state, action) => {
      state.isLoadingDetail = false;
      state.data = action.payload;
    },
  },
});

export const { 
  noError,
  unsetError,
  hasError,
  startLoading,
  startLoadingDetail,
  setDatas,
  setData,
} = slice.actions;

// 🔷 endpoint customer
const endpoint = "/customer";

// 🔷 SEARCH
export function searchData({ data = {}, params = {} } = {}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      let endpointURL = `${endpoint}/search`;

      Object.keys(params).forEach(key => {
        if (endpointURL.includes("?")) {
          endpointURL = `${endpointURL}&${key}=${params[key]}`;
        } else {
          endpointURL = `${endpointURL}?${key}=${params[key]}`;
        }
      });

      const response = await axios
        .post(endpointURL, data)
        ?.then(resp => resp?.data);

      if (response?.success) {
        // console.log("response.data",response.data);
        
        dispatch(slice.actions.setDatas(response.data));
      } else {
        dispatch(slice.actions.hasError(response));
      }

    } catch (error) {
      if (error?.response?.data) {
        dispatch(hasError(error.response.data));
      } else if (error?.message) {
        dispatch(hasError(error.message));
      } else {
        dispatch(hasError(error));
      }
    }
  };
}

// 🔷 ADD
export function addData({ formData }) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios
        .post(`${endpoint}`, formData)
        ?.then(resp => resp?.data);

      if (response?.success) {
        dispatch(slice.actions.noError());
        dispatch(searchData());
      } else {
        dispatch(slice.actions.hasError(response));
      }

    } catch (error) {
      if (error?.response?.data) {
        dispatch(hasError(error.response.data));
      } else if (error?.message) {
        dispatch(hasError(error.message));
      } else {
        dispatch(hasError(error));
      }
    }
  };
}

// 🔷 EDIT
export function editData({ id, formData, encryptedPin }) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      if (encryptedPin) {
        axios.defaults.headers.common.pin = encryptedPin;
      }

      const response = await axios
        .patch(`${endpoint}/${id}`, formData)
        ?.then(resp => resp?.data);

      if (response?.success) {
        dispatch(slice.actions.noError());
        dispatch(searchData());
      } else {
        dispatch(slice.actions.hasError(response));
      }

    } catch (error) {
      if (error?.response?.data) {
        dispatch(hasError(error.response.data));
      } else if (error?.message) {
        dispatch(hasError(error.message));
      } else {
        dispatch(hasError(error));
      }
    }
  };
}

// 🔷 DELETE (soft delete)
export function deleteData({ list_id, encryptedPin }) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      if (encryptedPin) {
        axios.defaults.headers.common.pin = encryptedPin;
      }

      const response = await axios.put(`${endpoint}/`, {
        id: list_id
      });

      if (response?.data?.success) {
        dispatch(slice.actions.noError());
        dispatch(searchData());
      } else {
        dispatch(slice.actions.hasError(response?.data));
      }

    } catch (error) {
      if (error?.response?.data) {
        dispatch(hasError(error.response.data));
      } else if (error?.message) {
        dispatch(hasError(error.message));
      } else {
        dispatch(hasError(error));
      }
    }
  };
}

export default slice.reducer;